import { useRef, useEffect, useState } from 'react'
import { motion, useInView } from 'framer-motion'
import gsap from 'gsap'
import { SPRING } from '@/lib/motion'

const STATS = [
  { val: 500, suffix: '+', label: 'Homes' },
  { val: 4.9, suffix: '★', label: 'Rating', decimals: 1 },
  { val: '24/7', label: 'Available' },
  { val: 100, suffix: '%', label: 'Guaranteed' }
]

function AnimatedNumber({
  value,
  suffix = '',
  decimals = 0
}: {
  value: number | string
  suffix?: string
  decimals?: number
}) {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true })
  const [display, setDisplay] = useState(0)

  useEffect(() => {
    if (!isInView || typeof value !== 'number') return

    const obj = { val: 0 }
    gsap.to(obj, {
      val: value,
      duration: 2,
      ease: 'power2.out',
      onUpdate: () => setDisplay(obj.val)
    })
  }, [isInView, value])

  if (typeof value === 'string') {
    return <span>{value}</span>
  }

  return (
    <span ref={ref}>
      {decimals > 0 ? display.toFixed(decimals) : Math.round(display)}
      {suffix}
    </span>
  )
}

export function Stats() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-80px' })

  return (
    <section
      ref={ref}
      style={{
        background: 'var(--lime)',
        padding: '80px max(5vw, 24px)'
      }}
    >
      <div
        style={{
          maxWidth: 1400,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 40,
          textAlign: 'center'
        }}
      >
        {STATS.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ delay: i * 0.12, ...SPRING }}
          >
            <div
              style={{
                fontFamily: 'Bebas Neue',
                fontSize: 'clamp(4rem, 8vw, 7rem)',
                color: 'var(--black)',
                lineHeight: 1
              }}
            >
              <AnimatedNumber
                value={stat.val}
                suffix={stat.suffix}
                decimals={stat.decimals}
              />
            </div>
            <div
              style={{
                fontFamily: 'DM Sans',
                fontSize: '1rem',
                fontWeight: 500,
                color: 'var(--black)',
                opacity: 0.7,
                marginTop: 8,
                textTransform: 'uppercase',
                letterSpacing: '0.1em'
              }}
            >
              {stat.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
